import React, { useState } from "react";
import { Table, Button, Input, Icon } from "semantic-ui-react";

let currentT = null;

const StockRow = ({
  shelf,
  missingAmount,
  confirmCallback,
  inputCallBack,
  currentTotal,
  forceLiftShelfCallback,
  cancelLiftShelfCallback,
  liftShelfForced,
  channels,
  hasChannels,
}) => {
  const [previous, setPrevious] = useState(0);
  var numberChange = (e) => {
    var target = e.target;

    clearTimeout(currentT);

    currentT = setTimeout(() => {
      var val = target.value;
      if (val < 0 || !val) {
        val = 0;
      }
      try {
        val = parseInt(val);
      } catch {
        val = 0;
      }

      if (val !== previous || val === 0) {
        var change = val - previous;
        var newTotal = currentTotal.total + change;

        var diff = newTotal - missingAmount;
        if (diff > 0) {
          newTotal -= diff;
          val -= diff;
        }

        target.value = val ? val : "";
        setPrevious(val);

        var shelfMatch = currentTotal.shelves.find((x) => x.shelfNumber === shelf.shelfNumber);
        if (shelfMatch) {
          var index = currentTotal.shelves.indexOf(shelfMatch);
          currentTotal.shelves[index].foundQuantity = val;
        } else {
          currentTotal.shelves.push({ shelfNumber: shelf.shelfNumber, foundQuantity: val });
        }

        var shelves = currentTotal.shelves.filter((x) => x.foundQuantity > 0);

        inputCallBack({ total: newTotal, shelves: shelves });
      }
    }, 100);
  };

  const forceLiftShelf = () => {
    forceLiftShelfCallback(shelf.shelfNumber);
  };

  const cancelLiftShelf = () => {
    cancelLiftShelfCallback(shelf.shelfNumber);
  };

  return (
    <Table.Row>
      <Table.Cell
        textAlign="left"
        style={{
          fontSize: "16px",
          fontWeight: shelf.isOriginalShelf ? "600" : "400",
          color: shelf.isOriginalShelf ? "rgb(109, 195, 0)" : "black",
        }}
      >
        {shelf.shelfNumber}
      </Table.Cell>
      <Table.Cell textAlign="left" className={hasChannels ? "" : "hidden"}>
        {channels.map(channel => <p key={channel}>{channel}</p>)}
      </Table.Cell>
      <Table.Cell textAlign="left">{shelf.stockQuantity}</Table.Cell>
      <Table.Cell className={missingAmount > 1 ? "" : "hidden"}>
        <Input type="number" style={{ width: "120px" }} onChange={numberChange} />
      </Table.Cell>
      <Table.Cell
        textAlign="right"
        className={missingAmount === 1 || shelf.isLiftShelf ? "" : "hidden"}
        style={{
          display: "flex",
        }}
      >
        <Button
          className={missingAmount === 1 ? "" : "hidden"}
          onClick={() => confirmCallback([{ shelfNumber: shelf.shelfNumber, foundQuantity: 1 }])}
          color="teal"
          style={{
            width: "110px",
          }}
        >
          Hittad här
        </Button>
        <Button
          className={shelf.isLiftShelf && !liftShelfForced ? "" : "hidden"}
          style={{
            width: "150px",
          }}
          icon
          labelPosition="right"
          onClick={forceLiftShelf}
          color="blue"
        >
          Hämta hiss
          <Icon name="right arrow" />
        </Button>
        <Button
          className={shelf.isLiftShelf && liftShelfForced ? "" : "hidden"}
          style={{
            width: "150px",
          }}
          icon
          labelPosition="right"
          onClick={cancelLiftShelf}
          color="red"
        >
          Ångra?
          <Icon name="cancel" />
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};
export default StockRow;
